import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { fetchReviews } from '../services/api';

const ReviewsSection = () => {
  const { language, t } = useLanguage();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews().then(setReviews).catch(() => {});
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-[#fffef2]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-[#333333] mb-4 tracking-wide">
            {t('reviews.title')}
          </h2>
          <p className="text-[#666666] text-base font-light">
            {t('reviews.subtitle')}
          </p>
          {/* Rating Badge */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 fill-[#b8860b] text-[#b8860b]"
                />
              ))}
            </div>
            <span className="text-[#333333] text-lg font-medium ml-2">5.0</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-[#f6f5e8] p-8 transition-all duration-300 hover:shadow-md"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-[#b8860b] text-[#b8860b]"
                  />
                ))}
              </div>
              {/* Quote */}
              <p className="text-[#333333] text-base leading-relaxed mb-6 italic">
                "{review.text[language]}"
              </p>
              {/* Author */}
              <p className="text-[#666666] text-sm font-medium">
                — {review.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
